import { _ as _asyncToGenerator, r as regenerator } from '../index-33ee6c9f.js';
import { _ as _defineProperty } from '../defineProperty-377d5a7f.js';
import fetchFactory from '../fetchFactory/index.js';
import { RequestHeaders, ResponseStatus, defaultErrorMessage } from '../configs/constants/index.js';
import { removeStorage } from '../services/browserStorage/index.js';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var validateAdditionalInfo = function validateAdditionalInfo(additionalInfo) {
  // eslint-disable-next-line guard-for-in
  for (var objKey in additionalInfo) {
    var validationRules = additionalInfo[objKey];
    var _iterator = _createForOfIteratorHelper(validationRules),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var rule = _step.value;
        var type = rule.type,
          message = rule.message;
        if (type === 'cantContain') {
          return message;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return undefined;
  }
};

var fetch = fetchFactory({
  baseUrl: '',
  withCache: false,
  headers: _defineProperty({}, RequestHeaders.platform, 'website'),
  withDeviceId: true,
  withLanguageHeader: true
});
var fetcher = function fetcher(url, options) {
  return fetch(url, options).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(response) {
      var responseData, message, status, reason, additionalError, errorObject;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return response.clone().json();
          case 2:
            responseData = _context.sent;
            message = responseData.message, status = responseData.status, reason = responseData.reason;
            if (!(!response.ok || status === ResponseStatus.error)) {
              _context.next = 8;
              break;
            }
            if (responseData !== null && responseData !== void 0 && responseData.additional_info) {
              additionalError = validateAdditionalInfo(responseData.additional_info);
            }
            errorObject = {
              message: additionalError || message || defaultErrorMessage,
              reason: reason,
              url: url
            };
            return _context.abrupt("return", Promise.reject(errorObject));
          case 8:
            return _context.abrupt("return", Promise.resolve(responseData));
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }())["catch"](function (e) {
    removeStorage(url, false);
    return Promise.reject(e);
  });
};

export { fetcher as default };
//# sourceMappingURL=index.js.map
